import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { clearAuthTokens, signout } from '../api/client'

/**
 * Sign-out page. Fire-and-forget the API call so the UI can never hang on a
 * slow / dead backend — token blacklisting finishes in the background. Mirrors
 * mms-ui/src/pages/SignOut.tsx so both UIs share the same UX and the same
 * enterable /signout URL.
 *
 * No cross-origin iframe cleanup: every UI's AuthProvider already has a
 * visibilitychange listener that clears local state when the access token
 * disappears from storage, so sibling tabs catch up on refocus.
 */
export default function SignOut() {
  const location = useLocation()
  const redirect = new URLSearchParams(location.search).get('redirect') || ''

  useEffect(() => {
    signout().catch(() => undefined)
    clearAuthTokens()

    const target = redirect
      ? `${redirect}${redirect.includes('?') ? '&' : '?'}signedOut=1`
      : '/signin'

    // replace() avoids leaving /signout in the back-stack — pressing Back from
    // /signin shouldn't re-trigger the sign-out flow.
    window.location.replace(target)
  }, [redirect])

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-950 text-gray-600 dark:text-gray-300 gap-3">
      <Loader2 size={20} className="animate-spin" />
      <span className="text-sm font-medium">Signing you out…</span>
    </div>
  )
}
